import React from "react";
import Collapsable from "../custom/Collapsable";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { red, orange } from "@material-ui/core/colors";
import clsx from "clsx";
import renderHTML from "lib/render-html";
import isArray from "lodash/isArray";
import { hasHtml } from "lib/helpers";
const useStyles = makeStyles((theme) => ({
  root: {},
  chip: {
    borderRadius: 10,
    fontSize: 18,
    height: 55,
    fontWeight: 500,
    padding: theme.spacing(0, 3),
  },
  shadowBrown: {
    boxShadow: `-5px 5px 0px 0px ${orange.A200}`,
  },
  shadowRed: {
    boxShadow: `-5px 5px 0px 0px ${red[300]}`,
  },
  borderBrown: {
    borderLeft: `1px solid ${orange.A200}`,
  },
  borderRed: {
    borderLeft: `1px solid ${red[300]}`,
  },
  colorRed: {
    "& li": {
      "&::before": {
        color: red[300],
      },
    },
  },
  colorBrown: {
    "& li": {
      "&::before": {
        color: orange.A200,
      },
    },
  },
  list: {
    margin: theme.spacing(0, 2),
    marginRight: 0,
    listStyle: "none",
    position: "relative",
    padding: 0,
    paddingLeft: theme.spacing(3),
    "& li": {
      padding: theme.spacing(2, 0),

      "&::before": {
        content: '"\\2022"',
        fontWeight: "bold",
        display: "inline-block",
        width: "0",
        height: 0,
        position: "absolute",
        left: -8,
        fontSize: 32,
        lineHeight: "16px",
      },
    },
    "& li:first-child": {
      paddingTop: theme.spacing(4),
    },
  },
}));

const EligibilityCriteria: React.FC<EligibilityCriteriaProps> = ({
  content,
}) => {
  const classes = useStyles();

  return (
    <Collapsable heading={content.topic_name} isOpen={true}>
      <Box className={classes.root}>
        {content.sub_heading ? (
          <Typography variant="h5" gutterBottom paragraph>
            {content.sub_heading}
          </Typography>
        ) : null}
        {content.description ? (
          <Typography
            gutterBottom
            paragraph
            component={hasHtml(content.description) ? "div" : "p"}
          >
            {isArray(content.description)
              ? renderHTML(content.description[0])
              : renderHTML(content.description)}
          </Typography>
        ) : null}

        <Grid container spacing={3} justifyContent="center">
          {content.contents &&
            content.contents?.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={5}
                lg={5}
                key={`eligibility-criteria-` + index}
              >
                <Chip
                  className={clsx(classes.chip, {
                    [classes.shadowBrown]: index < 1,
                    [classes.shadowRed]: index > 0,
                  })}
                  label={item.heading}
                  variant="outlined"
                />
                <ul
                  className={clsx(classes.list, {
                    [classes.borderBrown]: index < 1,
                    [classes.colorBrown]: index < 1,
                    [classes.borderRed]: index > 0,
                    [classes.colorRed]: index > 0,
                  })}
                >
                  {item.list?.map((point, i) => (
                    <li key={`eligibility-critria-point-` + i}>
                      {renderHTML(point)}
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Collapsable>
  );
};

export default EligibilityCriteria;
